import styled from 'styled-components';

// Background and layout components
export const Background = styled.div``;

export const Block = styled.div`
  width: 100%;
`;

export const DescriptionText = styled.p`
  color: var(--text-secondary, #808080);
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px;
  letter-spacing: 0.48px;
`;

export const Box = styled.div`
  margin: 20px 0px;

  > div {
    margin-bottom: 20px;
  }
`;

// Privacy consent components
export const PrivacyConsentBlock = styled.div`
  width: 100%;
  min-height: 100%;
  border-radius: 8px;
  padding: 32px;
  text-align: center;
  background-color: var(--primary-10, #EFF7F7);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`;

export const PrivacyTitle = styled.h3`
  color: var(--text-main, #1a1a1a);
  font-family: Roboto;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  line-height: 28px;
`;

export const PrivacyText = styled.p`
  color: var(--text-secondary, #666);
  font-family: Roboto;
  font-size: 14px;
  line-height: 20px;
  margin: 0;
  max-width: 500px;
  text-align: center;
`;

export const PrivacyLink = styled.a`
  color: var(--primary-40, #3baab0);
  text-decoration: none;
  font-weight: 500;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const ConsentCheckbox = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  
  input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    min-width: 24px;
    width: 20px;
    height: 20px;
    border: 2px solid var(--primary-40, #3baab0);
    border-radius: 4px;
    background-color: white;
    cursor: pointer;
    position: relative;
    transition: all 0.2s ease;
    
    &:checked {
      background-color: var(--primary-40, #3baab0);
      border-color: var(--primary-40, #3baab0);
      
      &::after {
        content: '';
        position: absolute;
        left: 6px;
        top: 2px;
        width: 6px;
        height: 10px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }
    }
    
    &:hover {
      border-color: var(--primary-50, #218b8f);
      box-shadow: 0 0 0 2px rgba(59, 170, 176, 0.1);
    }
    
    &:focus {
      outline: none;
      box-shadow: 0 0 0 3px rgba(59, 170, 176, 0.2);
    }
  }
  
  label {
    color: var(--text-main, #1a1a1a);
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    user-select: none;
    line-height: 1.4;
    
    &:hover {
      color: var(--primary-40, #3baab0);
    }
  }
`;

// Fixed bottom button for mobile
export const FixedBottomButton = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1px solid #e0e0e0;
  padding: 16px 20px;
  z-index: 1000;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 600px) {
    padding: 16px 20px;
  }
  
  .btn {
    width: 100%;
    margin: 0 auto;
    display: block;
    text-align: center;
    padding: 14px 24px;
    background: var(--primary-40, #3baab0);
    color: white;
    text-decoration: none;
    border-radius: 8px;
    font-weight: 600;
    font-size: 16px;
    transition: all 0.2s ease;
    box-sizing: border-box;
    
    &:hover {
      background: var(--primary-50, #218b8f);
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(59, 170, 176, 0.3);
    }
    
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      transform: none;
      box-shadow: none;
    }
  }
`;
